import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRootTokenSearch = 'Tools|CE Fee Vouchers|Token Search';

export type SPVoucherTokenSearchDialogLocs =
	| 'SPVoucherTokenSearchDialogTitle'
	| 'SPVoucherTokenSearchDialogTokenIdLabel'
	| 'SPVoucherTokenSearchDialogTokenIdRequired'
	| 'SPVoucherTokenSearchDialogSearchButton'
	| 'SPVoucherTokenSearchDialogCloseButton'
	| 'SPVoucherTokenSearchDialogResultsTitle'
	| 'SPVoucherTokenSearchDialogBatchId'
	| 'SPVoucherTokenSearchDialogRequirement'
	| 'SPVoucherTokenSearchDialogExpirationDate'
	| 'SPVoucherTokenSearchDialogRedeemedOn'
	| 'SPVoucherTokenSearchDialogRedeemedBy'
	| 'SPVoucherTokenSearchDialogStatus'
	| 'SPVoucherTokenSearchDialogRevokeButton'
	| 'SPVoucherTokenSearchDialogRevokeError'
	| 'SPVoucherTokenSearchDialogTokenNotFound'
	| 'SPVoucherTokenSearchDialogRevokeSuccess'
	| 'SPVoucherTokenSearchDialogInvalidateFeeLabel';

export const spVoucherTokenSearchDialogLocDefs: LocDefs<SPVoucherTokenSearchDialogLocs> = {
	SPVoucherTokenSearchDialogTitle: {
		defaultValue: 'Search Token',
		description: 'Title for the token search dialog.',
		displayPath: `${dpRootTokenSearch}|Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogTokenIdLabel: {
		defaultValue: 'Token ID',
		description: 'Label for the token ID input field.',
		displayPath: `${dpRootTokenSearch}|Token ID Label`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogTokenIdRequired: {
		defaultValue: 'Token ID is required.',
		description: 'Error message when token ID is required.',
		displayPath: `${dpRootTokenSearch}|Token ID Required`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogSearchButton: {
		defaultValue: 'Search',
		description: 'Button text to search for a token.',
		displayPath: `${dpRootTokenSearch}|Search Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogCloseButton: {
		defaultValue: 'Close',
		description: 'Button text to close the dialog.',
		displayPath: `${dpRootTokenSearch}|Close Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogResultsTitle: {
		defaultValue: 'Voucher Details',
		description: 'Title for the search results section.',
		displayPath: `${dpRootTokenSearch}|Results Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogBatchId: {
		defaultValue: 'Batch ID',
		description: 'Label for the batch ID field.',
		displayPath: `${dpRootTokenSearch}|Batch ID`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRequirement: {
		defaultValue: 'Requirement',
		description: 'Label for the requirement field.',
		displayPath: `${dpRootTokenSearch}|Requirement`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogExpirationDate: {
		defaultValue: 'Expiration Date',
		description: 'Label for the expiration date field.',
		displayPath: `${dpRootTokenSearch}|Expiration Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRedeemedOn: {
		defaultValue: 'Redeemed On',
		description: 'Label for the redeemed on field.',
		displayPath: `${dpRootTokenSearch}|Redeemed On`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRedeemedBy: {
		defaultValue: 'Redeemed By',
		description: 'Label for the redeemed by field.',
		displayPath: `${dpRootTokenSearch}|Redeemed By`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogStatus: {
		defaultValue: 'Revoked',
		description: 'Label for the revoked field.',
		displayPath: `${dpRootTokenSearch}|Revoked`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRevokeButton: {
		defaultValue: 'Revoke Token',
		description: 'Button text to revoke the token.',
		displayPath: `${dpRootTokenSearch}|Revoke Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRevokeError: {
		defaultValue: 'Error revoking token.',
		description: 'Error message when revoking token fails.',
		displayPath: `${dpRootTokenSearch}|Revoke Error`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogTokenNotFound: {
		defaultValue: 'Token not found.',
		description: 'Error message when token is not found.',
		displayPath: `${dpRootTokenSearch}|Token Not Found`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogRevokeSuccess: {
		defaultValue: 'Token revoked successfully.',
		description: 'Success message when token is revoked.',
		displayPath: `${dpRootTokenSearch}|Revoke Success`,
		displayType: 'Notification',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherTokenSearchDialogInvalidateFeeLabel: {
		defaultValue: 'Also invalidate related fee',
		description: 'Checkbox label for invalidating the related fee when revoking a token.',
		displayPath: `${dpRootTokenSearch}|Invalidate Fee Label`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const spVoucherTokenSearchDialogLocs = MapLocKeys<SPVoucherTokenSearchDialogLocs>(
	spVoucherTokenSearchDialogLocDefs
);

export type SPVoucherTokenSearchDialogLocKeys = typeof spVoucherTokenSearchDialogLocs;
